export const toEN = (number, end = undefined) => {
  number = number + '';
  number = number.replace(/[۱۲۳۴۵۶۷۸۹۰]/g, (x) => {
    let code = x.charCodeAt(0);
    code = code - 1728;
    return String.fromCharCode(code);
  });
  return number.replace(/\D/g, '').slice(0, end);
};
export default toEN;
